import { render } from "./AddContractPage.vue?vue&type=template&id=253c20ee"
import script from "./AddContractPage.vue?vue&type=script&lang=js"
export * from "./AddContractPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__